import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaTable from 'Components/UI/Meta/MetaTable';
import {
  useIdentityVerificationReviewsContext,
} from 'Components/AdvisorApp/Viewport/ApexAdminPortal/IdentityVerificationReviews/IdentityVerificationReviewsContext';
import { getIdentityVerificationReviewsTableFilters } from 'Overrides/identityVerificationReviewsOverride';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import IdentityVerificationMatchResultDialog from 'Components/Modals/IdentityVerificationReviewDetails';
import { QueryVal, removeQuery } from 'Helpers/Query';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    width: '100%',
  },
  mainHeaderTitle: {
    fontWeight: theme.typography.fontWeightBold,
    padding: theme.spacing(2, 3),
  },
});

const IdentityVerificationReviewContent = ({
  className,
  classes,
}) => {
  const {
    identityVerificationReviewsCollection,
    identityVerificationReviewsSelfLink,
    identityVerificationReviewsFilterLink,
    refreshIdentityVerificationReviewsCollection,
  } = useIdentityVerificationReviewsContext();
  const { householdSearch } = useSimpleHousehold();

  const [showDialog, setShowDialog] = useState(false);
  const [selectedResource, setSelectedResource] = useState({});

  const onReset = async () => {
    if (QueryVal(identityVerificationReviewsSelfLink)) {
      removeQuery(identityVerificationReviewsSelfLink);
    }

    refreshIdentityVerificationReviewsCollection();
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        className={classes.mainHeaderTitle}
        variant={'h2'}
        color="primary"
      >
        {'Identity Verification Reviews'}
      </Typography>
      <MetaTable
        collection={identityVerificationReviewsCollection}
        tableMetaOverrideSetName="IdentityVerificationReviewsTable"
        hasMetaQueryForm
        columns={[
          { name: 'householdId' },
          { name: 'dateSubmitted' },
          { name: 'clearingHouseAccountName' },
          { name: 'bankAccountName' },
          { name: 'status' },
          { name: 'assignedTo' },
          { name: 'decidedBy' },
          { name: 'dateReviewed' },
        ]}
        QueryFormProps={{
          getAvailableFilters: () => getIdentityVerificationReviewsTableFilters(identityVerificationReviewsCollection, householdSearch),
          onReset,
        }}
        linkQueryParamName={identityVerificationReviewsFilterLink}
        features={{
          onClick: (resource) => {
            setShowDialog(true);
            setSelectedResource(resource);
          },
        }}
      />
      <IdentityVerificationMatchResultDialog
        resource={selectedResource}
        show={showDialog}
        closeModal={() => {
          refreshIdentityVerificationReviewsCollection();
          setShowDialog(false);
        }}
      />;
    </Box>
  );
};

IdentityVerificationReviewContent.defaultProps = {
  className: '',
};

IdentityVerificationReviewContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IdentityVerificationReviewContent);
